import * as React from 'react';

import PropTypes from 'prop-types';

import axios from 'axios';

import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Datetime from 'components/Shared/Datetime';


import { ReclamationStatuts } from 'constants.js';

function WarningReclamationDialog({ warningReclamationIds, onWarningCancel, onIgnoreWarning })
{
    const [reclamations, setReclamations] = React.useState([]);

    // Fetch des fournisseurs
    React.useEffect(() => {
        const fetchData = async () => {

            var idsParam = warningReclamationIds.map(id => `ids=${id}`).join("&");            

            axios.get(`api/reclamations/entetes?${idsParam}`)
                .then((response) => {
                    setReclamations(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    //setError(true);
                })
                .then(() => {
                    // always executed
                    //setLoading(false);
                });
        };

        if (warningReclamationIds.length > 0)
        {
            fetchData();
        }
        else {
            setReclamations([]);
        }

    }, [warningReclamationIds]);



    return (

        <Dialog
            open={warningReclamationIds.length > 0}
            fullWidth
            maxWidth={"md"}
            scroll={'paper'}
        >
            <DialogTitle>
                {warningReclamationIds.length === 1 && (<span>Un dossier après-vente existe déjà sur cette pièce</span>)}
                {warningReclamationIds.length > 1 && (<span>Des dossiers après-vente existent déjà sur cette pièce</span>)}
            </DialogTitle>
            <DialogContent>

                <TableContainer component={Paper} sx={{ maxHeight: '100%' }} >
                    <Table size="small"  stickyHeader >
                        <TableHead>
                            <TableRow>
                                <TableCell>Dossier</TableCell>
                                <TableCell>Catégorie</TableCell>
                                <TableCell>Qualification</TableCell>
                                <TableCell>Émetteur</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>Date création</TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>Avoir généré</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reclamations.map((reclamation) => (
                                <TableRow
                                    key={reclamation.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        <Link
                                            to={`/reclamations/${reclamation.id}`}
                                            underline="hover"
                                            component={RouterLink}
                                            sx={{ fontWeight: 'bold' }}
                                        >
                                            {reclamation.id}
                                        </Link>
                                    </TableCell>
                                    <TableCell>{reclamation.categorie.libelle}</TableCell>
                                    <TableCell>{reclamation.qualification.libelle}</TableCell>
                                    <TableCell>{reclamation.emetteur.nom}</TableCell>
                                    <TableCell align="right">
                                        <Datetime datetime={reclamation.dateCreation} withTooltip />
                                    </TableCell>
                                    <TableCell>{ReclamationStatuts[reclamation.statut]}</TableCell>
                                    <TableCell>{reclamation.avoirGenere}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>







            </DialogContent>
            <DialogActions>
                <Button onClick={onWarningCancel} color="primary" >Annuler</Button>
                <Button
                    onClick={onIgnoreWarning}
                    variant="contained"
                    color="secondary"
                >
                    Poursuivre
                </Button>
            </DialogActions>
        </Dialog>

    );
}

WarningReclamationDialog.propTypes = {
    warningReclamationIds: PropTypes.array.isRequired,
    onWarningCancel: PropTypes.func.isRequired,
    onIgnoreWarning: PropTypes.func.isRequired,
};

WarningReclamationDialog.defaultProps = {
}


export default WarningReclamationDialog;